module.exports = __webpack_public_path__ + "static/media/pic4.a8bc511e.jpg";